function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAuthentication(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 500 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "freepik--Floor--inject-5"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 250,
    cy: 356.97,
    rx: 208.82,
    ry: 120.56,
    style: {
      fill: "#f5f5f5"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Shadows--inject-5"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 282.77,
    cy: 415.33,
    rx: 45.16,
    ry: 26.07,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M259.3,327.05,138.51,396.8c-3.4,2-9.33,1.72-13.26-.55L82.37,371.49c-3.92-2.26-4.35-5.69-1-7.65l120.79-69.75c3.4-2,9.33-1.72,13.26.55l42.88,24.76C262.27,321.66,262.7,325.09,259.3,327.05Z",
    style: {
      fill: "#e0e0e0"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Plants--inject-5"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M389.36,351.4l9.52,5.53s-4.8-15.32-2.14-30.74a29.73,29.73,0,0,1,3.87-10.26c.75-1.56,6.49-11.17,1.44-15.61s-16.9,4.39-16.37,28.13A92.24,92.24,0,0,0,389.36,351.4Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M389.36,351.4l9.52,5.53s-4.8-15.32-2.14-30.74a29.73,29.73,0,0,1,3.87-10.26c.75-1.56,6.49-11.17,1.44-15.61s-16.9,4.39-16.37,28.13A92.24,92.24,0,0,0,389.36,351.4Z",
    style: {
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M393.79,354.41a.44.44,0,0,1-.41-.29c0-.1-3.63-10.09-3.44-26.11s8.66-24.72,8.75-24.8a.42.42,0,0,1,.6,0,.43.43,0,0,1,0,.61c-.08.08-8.3,8.45-8.49,24.2s3.36,25.71,3.39,25.81a.42.42,0,0,1-.25.55Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M396.74,355.72,412.46,365s7.2-1.06,6.66-7.84-3.47-8.37.17-11.35,4.58-3.17,4.4-6.09-2.13-4.19-3.06-5.34-3.49-3.59-1.68-7.1,4.26-6.92.62-8.54c-2.18-1-5.84.25-8.26,2.82s-4.43,4.43-6.72,5-7.09.64-6.93,4.6,1.19,5.33.23,7.08C396.08,341.55,388.35,343.34,396.74,355.72Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M396.74,355.72,412.46,365s7.2-1.06,6.66-7.84-3.47-8.37.17-11.35,4.58-3.17,4.4-6.09-2.13-4.19-3.06-5.34-3.49-3.59-1.68-7.1,4.26-6.92.62-8.54c-2.18-1-5.84.25-8.26,2.82s-4.43,4.43-6.72,5-7.09.64-6.93,4.6,1.19,5.33.23,7.08C396.08,341.55,388.35,343.34,396.74,355.72Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M403.14,359.92a.43.43,0,0,1-.43-.4c0-.23-1.72-23.67,14.56-39.06a.43.43,0,1,1,.59.63c-16,15.1-14.3,38.13-14.28,38.36a.44.44,0,0,1-.4.47Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M406,339.83a.43.43,0,0,1-.43-.4,13.3,13.3,0,0,0-4.78-9.34.43.43,0,0,1,.51-.7,14,14,0,0,1,5.13,10,.43.43,0,0,1-.39.46Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M404.8,343.83a.42.42,0,0,1-.29-.11.44.44,0,0,1,0-.61c.17-.19,4.27-4.62,13.75-3.32a.45.45,0,0,1,.37.49.44.44,0,0,1-.49.37c-9-1.23-12.95,3-13,3A.4.4,0,0,1,404.8,343.83Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.12,337.94l-4.69,9.95s-4.75-15.34-15.69-26.53a29.38,29.38,0,0,0-9-6.25c-1.49-.86-11.67-5.52-10-12s16.4-6,29.44,13.87A92.08,92.08,0,0,1,101.12,337.94Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.12,337.94l-4.69,9.95s-4.75-15.34-15.69-26.53a29.38,29.38,0,0,0-9-6.25c-1.49-.86-11.67-5.52-10-12s16.4-6,29.44,13.87A92.08,92.08,0,0,1,101.12,337.94Z",
    style: {
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.94,343a.44.44,0,0,1-.42-.32c0-.1-2.7-10.23-11.85-23.18S66.07,304.41,66,304.39a.43.43,0,0,1-.35-.5.44.44,0,0,1,.5-.35c.12,0,12,2.3,21.28,15.46s12,23.36,12,23.46a.44.44,0,0,1-.31.53Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.5,345.69l-7.7,16.53s-6.53,3.21-9.92-2.68-1.9-8.86-6.58-9.25-5.58,0-7.09-2.51-.62-4.67-.51-6.14.85-4.94-2.64-6.81-7.44-3.27-5.35-6.67c1.24-2,4.94-3.11,8.4-2.36s6.15,1.13,8.38.32,6.2-3.49,8.32-.14,2,5.06,3.83,6C90,333.64,97.38,330.72,97.5,345.69Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.5,345.69l-7.7,16.53s-6.53,3.21-9.92-2.68-1.9-8.86-6.58-9.25-5.58,0-7.09-2.51-.62-4.67-.51-6.14.85-4.94-2.64-6.81-7.44-3.27-5.35-6.67c1.24-2,4.94-3.11,8.4-2.36s6.15,1.13,8.38.32,6.2-3.49,8.32-.14,2,5.06,3.83,6C90,333.64,97.38,330.72,97.5,345.69Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.36,352.85a.42.42,0,0,1-.37-.22c-.12-.2-11.81-20.11-33.53-23.48a.43.43,0,0,1-.36-.5.42.42,0,0,1,.49-.36c22.14,3.44,34,23.71,34.15,23.91a.44.44,0,0,1-.38.65Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.65,337.91a.44.44,0,0,1-.38-.22,14,14,0,0,1-1.43-11.13.43.43,0,1,1,.81.29A13.37,13.37,0,0,0,81,337.26a.43.43,0,0,1-.16.59A.39.39,0,0,1,80.65,337.91Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.06,345.51a.45.45,0,0,1-.32-.14.43.43,0,0,1,0-.61c7.06-6.45,13-5.13,13.2-5.07a.43.43,0,0,1,.32.52.42.42,0,0,1-.52.32c-.06,0-5.72-1.25-12.42,4.87A.46.46,0,0,1,71.06,345.51Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Device--inject-5"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M97.61,136.5a16.61,16.61,0,0,1,8.29-14.37L211.42,61.21a5.44,5.44,0,0,1,7.9,3.06,9.47,9.47,0,0,0-4.34-6l-.38-.22a17,17,0,0,0-8.68-2.39h0a5.4,5.4,0,0,0-2.78.74L97.62,117.35a16.58,16.58,0,0,0-8.3,14.37V359.91a5.44,5.44,0,0,0,8.15,4.71l.14-.08Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M211.28,308.48,105.76,369.4a5.43,5.43,0,0,1-8.15-4.7V136.5a16.61,16.61,0,0,1,8.29-14.37L211.42,61.21a5.44,5.44,0,0,1,8.15,4.71V294.11A16.59,16.59,0,0,1,211.28,308.48Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.61,364.7V136.5a16.57,16.57,0,0,1,1.64-7.18l-8.16-5a16.61,16.61,0,0,0-1.77,7.45v230.1a5.23,5.23,0,0,0,2.55,4.49l4.21,2.5a9.4,9.4,0,0,0,4.82,1.33H103A5.44,5.44,0,0,1,97.61,364.7Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M207.65,83.15V275a14.67,14.67,0,0,1-7.33,12.69l-93.18,53.79a4.74,4.74,0,0,1-2.31.64,4.8,4.8,0,0,0,6.81,2.25l93.18-53.8a14.65,14.65,0,0,0,7.32-12.69V87.93A4.78,4.78,0,0,0,207.65,83.15Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.83,342.07a4.74,4.74,0,0,0,2.31-.64l93.18-53.79A14.67,14.67,0,0,0,207.65,275V83.15a6.33,6.33,0,0,0-2.7.63l-93.18,53.79a14.65,14.65,0,0,0-7.33,12.69v189.9a4.87,4.87,0,0,0,.4,1.94Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.5
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M104.83,342.07a4.74,4.74,0,0,0,2.31-.64l93.18-53.79A14.67,14.67,0,0,0,207.65,275V83.15a6.33,6.33,0,0,0-2.7.63l-93.18,53.79a14.65,14.65,0,0,0-7.33,12.69v189.9a4.87,4.87,0,0,0,.4,1.94Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M143.82,109.46a3.73,3.73,0,0,1-1.67,2.91c-.93.53-1.68.1-1.68-1a3.72,3.72,0,0,1,1.68-2.91C143.07,108,143.82,108.39,143.82,109.46Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.07,105.86a3.74,3.74,0,0,1-1.68,2.91c-.93.53-1.68.1-1.68-1a3.72,3.72,0,0,1,1.68-2.91C149.31,104.36,150.07,104.79,150.07,105.86Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175.26,93.25,155,105c-.81.46-1.46,0-1.46-1.1h0a3.48,3.48,0,0,1,1.46-2.78l20.29-11.71c.8-.47,1.45,0,1.45,1.09h0A3.49,3.49,0,0,1,175.26,93.25Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171.83,315.68h0c1.21,0,2,1.29,2,3.28,0,3.12-1.95,6.89-4.27,8.23l-9.71,5.61a3,3,0,0,1-1.44.45c-1.21,0-2-1.29-2-3.28,0-3.13,2-6.9,4.27-8.23l9.71-5.61a3,3,0,0,1,1.45-.45m0-.83a3.68,3.68,0,0,0-1.86.57l-9.71,5.6c-2.59,1.49-4.69,5.5-4.69,9,0,2.57,1.17,4.11,2.83,4.11a3.68,3.68,0,0,0,1.86-.57l9.71-5.6c2.58-1.49,4.68-5.5,4.68-9,0-2.57-1.16-4.11-2.82-4.11Z",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Screen--inject-5"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M118.19,163.71v215c0,3.9,1.43,6.51,3.61,7.37l.06,0h0l9.3,5.09-.06-8.26-1-222.93-9.81-5A21.16,21.16,0,0,0,118.19,163.71Z",
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.67,392l-10.06-5.51c-2.49-1-3.92-3.93-3.92-7.83v-215a21.64,21.64,0,0,1,2.13-9l.22-.47,10.54,5.39v.3l1,222.93Zm-9.55-6.37,8.54,4.68,0-7.42-1-222.63-9.07-4.64a20.5,20.5,0,0,0-1.82,8.06v215c0,3.52,1.23,6.1,3.3,6.91l.12.06Z",
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.27,155l9.81,5,105-61.09,7-4.08-9.69-5.46-.27-.16h0c-1.55-.93-3.57-.87-5.8.42L126.94,147A17.87,17.87,0,0,0,120.27,155Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.08,160.49a.49.49,0,0,1-.23-.06l-9.81-5a.48.48,0,0,1-.22-.65,18.44,18.44,0,0,1,6.87-8.2l99.4-57.39c2.3-1.32,4.54-1.47,6.3-.41l.08,0,.2.12,9.68,5.45a.52.52,0,0,1,.25.44.48.48,0,0,1-.25.43l-112,65.17A.52.52,0,0,1,130.08,160.49Zm-9.15-5.75,9.14,4.68,111-64.59-9.21-5.2-.07-.06c-1.43-.82-3.28-.65-5.22.47l-99.4,57.39A17.21,17.21,0,0,0,120.93,154.74Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.81,169.11v214c0,3.37,1.08,5.79,2.79,6.93l.57.31c1.49.7,3.36.55,5.39-.63L184.61,362,236,331.1a18.66,18.66,0,0,0,8.76-15.47v-214c0-3.26-1-5.62-2.62-6.81a3.9,3.9,0,0,0-.89-.5A5.86,5.86,0,0,0,236,95l-99.4,58.36a15,15,0,0,0-6.48,6.62A21.26,21.26,0,0,0,127.81,169.11Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M236,331.1c-20.45,12.2-73.66,43.95-100,59.82a5.18,5.18,0,0,1-7.84-4.44V166.42a14.36,14.36,0,0,1,7.1-12.39L236.44,94.71a5.18,5.18,0,0,1,7.79,4.46V316.53A17,17,0,0,1,236,331.1Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M235.71,330.66Q211.62,345,187.55,359.42l-28.5,17.05-13,7.8-5.69,3.42c-1.75,1.05-3.61,2.55-5.55,3.22-3.21,1.12-6.1-1.45-6.18-4.62,0-.51,0-1,0-1.53V183c0-5.37,0-10.75,0-16.12a14.29,14.29,0,0,1,7.14-12.58c2.32-1.37,4.65-2.72,7-4.08L175.43,131l38.75-22.71c7.35-4.3,14.68-8.64,22-12.92,2.28-1.32,5.15-1.19,6.74,1.2a5.56,5.56,0,0,1,.76,3.16V315.69a17,17,0,0,1-8,15c-.55.34-.05,1.21.5.87a18,18,0,0,0,8.52-15.7V115.11c0-5.22.05-10.45,0-15.68a5.77,5.77,0,0,0-8.88-5c-2.44,1.41-4.86,2.85-7.28,4.27L195,118.43l-39.1,22.92C149,145.4,142,149.42,135.13,153.5a15.24,15.24,0,0,0-7.51,13.31c0,1.8,0,3.6,0,5.4V385.44c0,.34,0,.69,0,1a5.74,5.74,0,0,0,7.45,5.41c1.89-.63,3.67-2.05,5.37-3.07l5.8-3.49,13-7.78q28.36-17,56.77-33.94l20.23-12.07C236.76,331.2,236.26,330.33,235.71,330.66Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.22,154,236.44,94.71a5.18,5.18,0,0,1,7.79,4.46v9.55h0l-116.08,67v-9.32A14.36,14.36,0,0,1,135.22,154Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 186.17,
    cy: 195.33,
    rx: 37.17,
    ry: 21.46,
    transform: "translate(-76.07 258.89) rotate(-60)",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 186.17,
    cy: 195.33,
    rx: 37.17,
    ry: 21.46,
    transform: "translate(-76.07 258.89) rotate(-60)",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M181.46,195.44a1.18,1.18,0,0,1-1.18-1.18v-7.77a11.57,11.57,0,0,1,5.3-9.19,4,4,0,0,1,6.49,3.74v7.78a1.18,1.18,0,0,1-2.36,0V181a1.74,1.74,0,0,0-3-1.7,9.31,9.31,0,0,0-4.12,7.15v7.77A1.18,1.18,0,0,1,181.46,195.44Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M195.7,183.81A1.77,1.77,0,0,0,194,184l-15.72,9.08a4.89,4.89,0,0,0-1.66,1.74,6.74,6.74,0,0,0-1,3.39v13.61a2.53,2.53,0,0,0,.78,2.07,1.12,1.12,0,0,0,.28.16h0a1.77,1.77,0,0,0,1.62-.2L194,204.76a6.42,6.42,0,0,0,2.69-5.13V186A2.28,2.28,0,0,0,195.7,183.81Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M188,198l1.52,4.36-5.33,3.07,1.33-5.38.19-.76c-.9,0-1.52-.67-1.52-1.89a4.77,4.77,0,0,1,.25-1.46,5.92,5.92,0,0,1,2.41-3.16c1.47-.85,2.67-.16,2.67,1.54A6,6,0,0,1,188,198Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M185.48,200l.19-.76c-.9,0-1.52-.67-1.52-1.89a4.77,4.77,0,0,1,.25-1.46L188,198l1.52,4.36Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225,245.66,147.4,290.43c-3.21,1.85-5.81-.12-5.81-4.39V274.29c0-4.28,2.6-9.25,5.81-11.1L225,218.42c3.21-1.85,5.81.11,5.81,4.39v11.75C230.76,238.84,228.16,243.8,225,245.66Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 159.85,
    y: 262.13,
    width: 1.5,
    height: 12.43,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 154.39,
    y: 267.6,
    width: 12.43,
    height: 1.5,
    transform: "matrix(0.87, -0.5, 0.5, 0.87, -112.67, 116.28)",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 159.85,
    y: 263.95,
    width: 1.5,
    height: 8.79,
    transform: "translate(-152.1 273.27) rotate(-60)",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 152.99,
    y: 267.6,
    width: 15.23,
    height: 1.5,
    transform: "matrix(0.5, -0.87, 0.87, 0.5, -152.1, 273.24)",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 185.42,
    y: 248.21,
    width: 1.5,
    height: 12.43,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 179.96,
    y: 253.67,
    width: 12.43,
    height: 1.5,
    transform: "translate(-102.28 127.2) rotate(-30)",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 185.42,
    y: 250.03,
    width: 1.5,
    height: 8.79,
    transform: "translate(-127.25 288.45) rotate(-60)",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 178.56,
    y: 253.67,
    width: 15.23,
    height: 1.5,
    transform: "matrix(0.5, -0.87, 0.87, 0.5, -127.25, 288.42)",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 210.99,
    y: 234.28,
    width: 1.5,
    height: 12.43,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 205.53,
    y: 239.75,
    width: 12.43,
    height: 1.5,
    transform: "matrix(0.87, -0.5, 0.5, 0.87, -91.89, 138.11)",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 210.99,
    y: 236.1,
    width: 1.5,
    height: 8.79,
    transform: "translate(-102.4 303.63) rotate(-60)",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 204.13,
    y: 239.75,
    width: 15.23,
    height: 1.5,
    transform: "translate(-102.41 303.61) rotate(-60)",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M227.25,261.84c1,0,1.51,1.55,1.51,3.09v11.75c0,3.57-2.21,7.86-4.81,9.37L146.4,330.82a2.78,2.78,0,0,1-1.31.43c-1,0-1.5-1.55-1.5-3.09V316.41c0-3.57,2.2-7.86,4.81-9.37L226,262.27a2.75,2.75,0,0,1,1.3-.43m0-2a4.7,4.7,0,0,0-2.3.7L147.4,305.31c-3.21,1.85-5.81,6.82-5.81,11.1v11.75c0,3.18,1.44,5.09,3.5,5.09a4.7,4.7,0,0,0,2.31-.7L225,287.78c3.21-1.85,5.81-6.82,5.81-11.1V264.93c0-3.18-1.45-5.09-3.51-5.09Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(0.87, -0.5, 0, 1, 167.15, 310.95)",
    style: {
      fontSize: "11.608570098876953px",
      fill: "#407BFF",
      fontFamily: "Montserrat-ExtraBold, Montserrat",
      fontWeight: 800,
      letterSpacing: "0.200045513897026em"
    }
  }, "en", /*#__PURE__*/React.createElement("tspan", {
    x: 19.58,
    y: 0,
    style: {
      letterSpacing: "0.1990360327503631em"
    }
  }, "t"), /*#__PURE__*/React.createElement("tspan", {
    x: 27.11,
    y: 0,
    style: {
      letterSpacing: "0.1999613904681374em"
    }
  }, "er"))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Fingerprint--inject-5"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M341.39,128.31a5,5,0,0,0,2.31,3.93c1.28.72,2.31.13,2.31-1.31A5,5,0,0,0,343.7,127C342.43,126.28,341.39,126.86,341.39,128.31Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M310.42,137.62a11.79,11.79,0,0,1-5.75-1.72l-7.33-4.15a.5.5,0,1,1,.49-.87l7.33,4.15c3.17,1.79,6.1,2.08,8.27.82s3.3-3.85,3.3-7.36c0-3.87,1.35-6.79,3.79-8.22s5.79-1.16,9.27.81l11.85,6.71a.51.51,0,0,1,.19.68.5.5,0,0,1-.68.19L329.3,122c-3.16-1.79-6.1-2.08-8.27-.81s-3.3,3.85-3.3,7.35c0,3.88-1.35,6.8-3.79,8.22A6.92,6.92,0,0,1,310.42,137.62Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M294.31,129.51a4,4,0,0,0,1.87,3.17c1,.59,1.87.11,1.87-1.06a4,4,0,0,0-1.87-3.17C295.15,127.86,294.31,128.34,294.31,129.51Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M412.59,118.88l-49-27.74a3,3,0,0,0-3.55,0l-4.24,2.92,2.89,3.57v51.63c0,3.61,2.2,7.8,4.9,9.37l47.77,27,.22,3.84,4.46-3.06a4.59,4.59,0,0,0,1.44-3.79V128.25C417.5,124.64,415.3,120.45,412.59,118.88Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M412.59,118.88l-49-27.74a3,3,0,0,0-3.55,0l-4.24,2.92,2.89,3.57v51.63c0,3.61,2.2,7.8,4.9,9.37l47.77,27,.22,3.84,4.46-3.06a4.59,4.59,0,0,0,1.44-3.79V128.25C417.5,124.64,415.3,120.45,412.59,118.88Z",
    style: {
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M408.43,189.23l-49-27.74c-2.71-1.56-4.9-5.76-4.9-9.37V97.72c0-3.62,2.19-5.28,4.9-3.71l49,27.74c2.71,1.56,4.9,5.76,4.9,9.37v54.41C413.33,189.14,411.14,190.8,408.43,189.23Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M398.14,142.15a.5.5,0,0,1-.49-.37,40.15,40.15,0,0,0-4.79-10.92.5.5,0,0,1,.15-.69.49.49,0,0,1,.69.16,41.11,41.11,0,0,1,4.92,11.19.52.52,0,0,1-.35.62Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M399.26,152.32h0a.51.51,0,0,1-.47-.54c0-.53.06-1.09.06-1.66a30.17,30.17,0,0,0-.45-5.1.5.5,0,1,1,1-.17,31.16,31.16,0,0,1,.47,5.27c0,.59,0,1.17-.06,1.73A.51.51,0,0,1,399.26,152.32Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M368.67,135.72a.49.49,0,0,1-.49-.45c-.08-.87-.12-1.74-.12-2.58,0-4.85,1.31-8.85,3.69-11.28a.49.49,0,0,1,.7,0,.5.5,0,0,1,0,.71c-2.19,2.24-3.4,6-3.4,10.58,0,.81,0,1.65.11,2.49a.49.49,0,0,1-.45.54Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M390.79,127.63a.5.5,0,0,1-.39-.18,24.18,24.18,0,0,0-6.71-5.88c-3.32-1.88-6.44-2.24-9-1a.5.5,0,0,1-.66-.24.5.5,0,0,1,.24-.67c2.88-1.33,6.31-1,9.93,1.09a25.39,25.39,0,0,1,7,6.12.5.5,0,0,1-.07.7A.5.5,0,0,1,390.79,127.63Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M372.12,136.11a.5.5,0,0,1-.5-.48c0-.31,0-.62,0-.93,0-3.55.87-6.45,2.52-8.38a.49.49,0,0,1,.7-.06.51.51,0,0,1,.06.71c-1.49,1.75-2.28,4.42-2.28,7.73,0,.29,0,.59,0,.88a.5.5,0,0,1-.48.52Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M376,125.81a.5.5,0,0,1-.26-.93A6.66,6.66,0,0,1,380,124a.5.5,0,0,1,.45.54.51.51,0,0,1-.55.45,5.7,5.7,0,0,0-3.62.78A.56.56,0,0,1,376,125.81Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M398.14,158.75a.51.51,0,0,1-.47-.31l-.58-1.45a23.76,23.76,0,0,1-1.81-8.84c0-8.48-5.2-18.29-11.59-21.91a.49.49,0,0,1-.18-.68.49.49,0,0,1,.68-.19c6.66,3.78,12.09,14,12.09,22.74a22.59,22.59,0,0,0,1.74,8.5l.58,1.45a.49.49,0,0,1-.27.65A.46.46,0,0,1,398.14,158.75Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M375.18,153a.5.5,0,0,1-.47-.33,62.6,62.6,0,0,1-3.11-14.6.5.5,0,0,1,.47-.54.52.52,0,0,1,.53.47,61.54,61.54,0,0,0,3,14.33.49.49,0,0,1-.3.64A.47.47,0,0,1,375.18,153Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M395.2,162.12a.49.49,0,0,1-.47-.32l-1.34-3.6a32.36,32.36,0,0,1-2.15-11v-3.93c0-4.67-3.35-10.36-7.47-12.69-1.92-1.09-3.7-1.28-5-.52s-2,2.33-2,4.46V138a46.87,46.87,0,0,0,3.34,16.49l1.65,4.3a.5.5,0,0,1-.29.65.5.5,0,0,1-.64-.29l-1.65-4.3A48,48,0,0,1,375.8,138v-3.47c0-2.5.87-4.39,2.47-5.32s3.75-.76,6,.51c4.39,2.49,8,8.57,8,13.56v3.93a31.2,31.2,0,0,0,2.09,10.65l1.33,3.59a.49.49,0,0,1-.29.64Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M390.79,163.55a.5.5,0,0,1-.48-.35l-.7-2.36a45.27,45.27,0,0,1-2-12.78V142a8.66,8.66,0,0,0-4-6.82,2.56,2.56,0,0,0-2.54-.28,2.46,2.46,0,0,0-1,2.26c0,6.76,2.06,14.55,5.79,21.94l1.41,2.79a.5.5,0,0,1-.9.45l-1.4-2.79c-3.81-7.53-5.9-15.48-5.9-22.39a3.4,3.4,0,0,1,1.48-3.13,3.51,3.51,0,0,1,3.53.28,9.78,9.78,0,0,1,4.53,7.69v6.08a44.07,44.07,0,0,0,1.95,12.5l.7,2.35a.49.49,0,0,1-.34.62A.34.34,0,0,1,390.79,163.55Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M385.18,153a.51.51,0,0,1-.49-.39l-.46-2.14a29.91,29.91,0,0,1-.66-6.26v-5.63a.5.5,0,1,1,1,0v5.63a29.25,29.25,0,0,0,.64,6l.46,2.14a.49.49,0,0,1-.38.59Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M369.76,142.15a.51.51,0,0,1-.5-.45l-.29-2.92a.51.51,0,0,1,.45-.55.49.49,0,0,1,.55.45l.29,2.92a.5.5,0,0,1-.45.55Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--face-recognition--inject-5"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M412.59,211.54l-49-27.75a3,3,0,0,0-3.55,0l-4.24,2.92,2.89,3.57v51.63c0,3.61,2.2,7.8,4.9,9.37l47.77,27,.22,3.84,4.46-3.05a4.61,4.61,0,0,0,1.44-3.8v-54.4C417.5,217.29,415.3,213.1,412.59,211.54Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M412.59,211.54l-49-27.75a3,3,0,0,0-3.55,0l-4.24,2.92,2.89,3.57v51.63c0,3.61,2.2,7.8,4.9,9.37l47.77,27,.22,3.84,4.46-3.05a4.61,4.61,0,0,0,1.44-3.8v-54.4C417.5,217.29,415.3,213.1,412.59,211.54Z",
    style: {
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M408.43,281.88l-49-27.74c-2.71-1.56-4.9-5.75-4.9-9.37v-54.4c0-3.61,2.19-5.27,4.9-3.71l49,27.74c2.71,1.57,4.9,5.76,4.9,9.37v54.41C413.33,281.79,411.14,283.45,408.43,281.88Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M365.45,205.55a.5.5,0,0,1-.5-.5v-3.37a1.88,1.88,0,0,1,.95-1.65,1.94,1.94,0,0,1,2,0l3.53,2a.5.5,0,0,1-.49.88l-3.54-2a1,1,0,0,0-1,0,.88.88,0,0,0-.45.78v3.37A.5.5,0,0,1,365.45,205.55Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M371.13,251.92a.53.53,0,0,1-.24-.06l-3.3-1.87A5.17,5.17,0,0,1,365,245.5v-3.11a.5.5,0,1,1,1,0v3.11a4.17,4.17,0,0,0,2.13,3.62l3.3,1.87a.5.5,0,0,1-.25.93Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M401,268.63a1.91,1.91,0,0,1-1-.26l-3.53-2a.5.5,0,0,1-.19-.68.51.51,0,0,1,.68-.19l3.54,2a1,1,0,0,0,1,0,.88.88,0,0,0,.45-.78v-3.37a.5.5,0,0,1,1,0v3.37a1.87,1.87,0,0,1-.95,1.64A1.93,1.93,0,0,1,401,268.63Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M402.43,226.5a.5.5,0,0,1-.5-.5v-3.11a4.15,4.15,0,0,0-2.13-3.61l-3.3-1.87a.51.51,0,0,1-.19-.69.49.49,0,0,1,.68-.18l3.3,1.87a5.17,5.17,0,0,1,2.64,4.48V226A.5.5,0,0,1,402.43,226.5Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M369.88,222.37a68.93,68.93,0,0,0,2.42,16.8c3.8,14.34,18.79,23.15,22.91,13.44A38.21,38.21,0,0,0,398,237.56c0-8.8-6.3-19.5-14.06-23.9C376,209.17,369.77,213.34,369.88,222.37Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "383.44 230.38 383.44 239.8 379.35 236.74 383.44 230.38",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M375.83,224.75a2.94,2.94,0,0,0,1.34,2.3c.75.42,1.35.08,1.35-.77a2.9,2.9,0,0,0-1.35-2.29C376.43,223.57,375.83,223.91,375.83,224.75Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M388.35,231.93a2.93,2.93,0,0,0,1.35,2.29c.75.42,1.35.08,1.35-.76a2.92,2.92,0,0,0-1.35-2.3C389,230.74,388.35,231.08,388.35,231.93Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M382.09,244.41l4.57-.77S385.69,248.52,382.09,244.41Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M341.39,215.72a5,5,0,0,0,2.31,3.92c1.28.73,2.31.14,2.31-1.3a5,5,0,0,0-2.31-3.93C342.43,213.68,341.39,214.27,341.39,215.72Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M341.48,216.81a.57.57,0,0,1-.25-.06L329.39,210c-6.93-3.92-12.57-13.51-12.57-21.36,0-7.54-5.41-16.73-12.06-20.5l-7.42-4.2a.5.5,0,0,1-.19-.68.49.49,0,0,1,.68-.19l7.42,4.2c6.93,3.93,12.57,13.51,12.57,21.37,0,7.53,5.41,16.72,12.06,20.49l11.85,6.72a.5.5,0,0,1,.19.68A.52.52,0,0,1,341.48,216.81Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M294.31,161.54a4.06,4.06,0,0,0,1.87,3.18c1,.58,1.87.11,1.87-1.06a4.06,4.06,0,0,0-1.87-3.18C295.15,159.9,294.31,160.37,294.31,161.54Z",
    style: {
      fill: "#455a64"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Character--inject-5"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M308.38,253.2s7.29-.49,11.42,9.64c2.57,6.3,5.7,16,7.7,22.5a10.44,10.44,0,0,1-3.26,11.08l-12.71,10.67L307,298.82a87.18,87.18,0,0,1,8.69-9.93L307,262.84Z",
    style: {
      fill: "#ffa8a7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M311.74,284.14s11.58,1.53,14.47-7.4c0,0-5-13.07-7.24-17.41s-6.92-7.5-10.59-6.13S311.74,284.14,311.74,284.14Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M311.74,284.14s11.58,1.53,14.47-7.4c0,0-5-13.07-7.24-17.41s-6.92-7.5-10.59-6.13S311.74,284.14,311.74,284.14Z",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M304,401.4s-5.5-4.71-7.64-4.93-5.84,3.44-2.71,9.79c.87,1.77,4.41,3.68,6.62,7.07s4.19,5.94,7.58,5.47,3.83-2.37,3.61-4.58a52.71,52.71,0,0,0-1.21-6Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M308,417.79c-3.49.48-5.54-2.15-7.82-5.64s-5.92-5.47-6.82-7.29a13.66,13.66,0,0,1-.88-2.27,11.24,11.24,0,0,0,1.14,3.67c.87,1.77,4.41,3.68,6.62,7.07s4.19,5.94,7.58,5.47c2.6-.35,3.46-1.56,3.62-3.1C311,416.74,310.05,417.52,308,417.79Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M301.08,407.46a.45.45,0,0,1-.25-.07.53.53,0,0,1-.22-.72,8.62,8.62,0,0,1,5.17-4.06.54.54,0,0,1,.24,1.05,7.63,7.63,0,0,0-4.47,3.51A.54.54,0,0,1,301.08,407.46Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M299,405.56a.57.57,0,0,1-.25-.06.53.53,0,0,1-.22-.72,8.58,8.58,0,0,1,5.18-4.06.53.53,0,1,1,.23,1,7.67,7.67,0,0,0-4.47,3.52A.52.52,0,0,1,299,405.56Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M296.67,403.67a.57.57,0,0,1-.25-.06.54.54,0,0,1-.22-.73,8.61,8.61,0,0,1,5.18-4.05.53.53,0,0,1,.64.4.54.54,0,0,1-.41.64,7.67,7.67,0,0,0-4.47,3.52A.52.52,0,0,1,296.67,403.67Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M274.73,416.85s-7.37-2.39-9.57-1.73-4.35,5.8,1.35,10.79c1.58,1.38,5.86,1.82,9.44,4.26s6.58,4.13,9.74,2.28,2.9-4,2.33-6.28c-.71-2.94-1.29-5.08-1.29-5.08Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M285.45,431.38c-3.25,1.91-6.36.16-10-2.36s-8.1-3-9.73-4.39a14.37,14.37,0,0,1-1.81-1.89,12,12,0,0,0,2.64,3.17c1.58,1.38,5.86,1.82,9.44,4.26s6.58,4.13,9.74,2.28c2.41-1.41,2.77-3,2.3-4.55C288,429.11,287.32,430.28,285.45,431.38Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M273,423.66h-.05a.54.54,0,0,1-.48-.59,9.15,9.15,0,0,1,3.43-6.1.53.53,0,0,1,.74.12.54.54,0,0,1-.12.75,8.25,8.25,0,0,0-3,5.34A.53.53,0,0,1,273,423.66Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M276,424.65H276a.54.54,0,0,1-.48-.58,9.21,9.21,0,0,1,3.43-6.11.54.54,0,0,1,.75.13.53.53,0,0,1-.13.74,8.2,8.2,0,0,0-3,5.34A.53.53,0,0,1,276,424.65Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M270.16,422.63h-.05a.54.54,0,0,1-.48-.58,9.16,9.16,0,0,1,3.43-6.11.53.53,0,0,1,.62.87,8.2,8.2,0,0,0-3,5.34A.53.53,0,0,1,270.16,422.63Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M310.6,402.8c.66-7.3,2.09-18.74,2.69-24.09a69.13,69.13,0,0,0-.58-20.31,16.79,16.79,0,0,1-.23-4.8c1.45-14.54,2.39-38.11,1.59-43.29l-20.41,4.32s2.5,33.07,3.6,44.07,5.2,44.2,5.2,44.2A7.41,7.41,0,0,0,310.6,402.8Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M307.66,410.31a3.84,3.84,0,0,0,2.6-2.1c0-1.15.13-3.07.34-5.41a7.41,7.41,0,0,1-8.14.1l.72,6.14A5.28,5.28,0,0,0,307.66,410.31Z",
    style: {
      fill: "#ffa8a7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M287.64,415.64c.83-11.06,2.44-32.47,2.65-35.84a53.09,53.09,0,0,0-.7-11.11,16.75,16.75,0,0,1,0-6l9-49.78-24.67-.36-1.61,52.15a15,15,0,0,0,.08,2l5.23,48.61h0S282.72,419.6,287.64,415.64Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M283.52,424.76a4.64,4.64,0,0,0,3.62-2.54l.5-6.58c-4.92,4-10-.31-10-.31h0l.78,7.28S279.56,425.13,283.52,424.76Z",
    style: {
      fill: "#ffa8a7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M285.32,256.52l-5.82,2-6.26,29.61.31,26.25s4.47,3.57,21.93,3.57c9.8,0,16.19-3.7,18.59-7.63l-1.57-15.86s1.57-15.63,1.57-23.36.35-14.06-5.69-17.89l-5.38.45Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M285.32,256.52l-5.82,2-6.26,29.61.31,26.25s4.47,3.57,21.93,3.57c9.8,0,16.19-3.7,18.59-7.63l-1.57-15.86s1.57-15.63,1.57-23.36.35-14.06-5.69-17.89l-5.38.45Z",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M279,231.07l-2.91,5.77a.65.65,0,0,0,.38.91l3.45,1.16Z",
    style: {
      fill: "#f28f8f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M283,221.4s-4.42,2.38-4.42,16c0,7.51.52,12.3,4.42,12s15.14-1.77,15.14-1.77V221.4Z",
    style: {
      fill: "#ffa8a7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M283,249.45c1.37-.11,3.65-.36,6-.64v-1.39a31.1,31.1,0,0,1-6.68,2A4.63,4.63,0,0,0,283,249.45Z",
    style: {
      fill: "#f28f8f"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "288.4 246.84 288.4 255.41 300.13 255.41 300.13 243.37 288.4 246.84",
    style: {
      fill: "#ffa8a7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M288.4,252.15s4.22,1.5,7.6.91,4.13-2.65,4.13-2.65,1.1-.09,2.87,3.24a8.63,8.63,0,0,1-6.85,4.42,26.73,26.73,0,0,1-10.83-1.55S287,251.72,288.4,252.15Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M288.4,252.15s4.22,1.5,7.6.91,4.13-2.65,4.13-2.65,1.1-.09,2.87,3.24a8.63,8.63,0,0,1-6.85,4.42,26.73,26.73,0,0,1-10.83-1.55S287,251.72,288.4,252.15Z",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M262.23,277.59l-3.15,4.84s-7.65-3.41-13-5.48a29.83,29.83,0,0,1-8.58-4.94,45.67,45.67,0,0,1,1-6.19c.62-2.1.83-3.85-1-2.92s-3.1,4.54-3.21,5c0,0-10.75-10.81-12.09-10.57s-1,1.86,1.86,5.19l2.89,3.34s-6.59,3.79-5.52,7.93,9.76,6,9.76,6,25.43,19.54,31.06,16,13.6-13.65,13.6-13.65Z",
    style: {
      fill: "#ffa8a7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M281.81,257.75s4.7,3.86,1.64,11.84-10.87,17.62-10.87,17.62-8.18-2.55-11.34-9.16l10.32-16.15a8.68,8.68,0,0,1,6.75-4C279.29,257.84,280.45,257.79,281.81,257.75Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M281.81,257.75s4.7,3.86,1.64,11.84-10.87,17.62-10.87,17.62-8.18-2.55-11.34-9.16l10.32-16.15a8.68,8.68,0,0,1,6.75-4C279.29,257.84,280.45,257.79,281.81,257.75Z",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M281.35,213.36s-4.64-.62-5.82,2.57c-.74,2,1.62,3.54,1.62,3.54s-3,2.81,1.47,3.68a2.94,2.94,0,0,0,3.61,3.32s-.52,3,3.39,4.09c0,0-2,5.26,1.74,5.33h3.47l-1.4,4.06s2.6,6.26,10.7,6.26a52.55,52.55,0,0,1,3-5.53c1-1.25,6-7.66,6-12.74s-1.95-8.09-4.66-8.76a11.59,11.59,0,0,0-3.88-4.65c-2.73-1.84-8.47-3.48-11.71-1.22,0,0-2.87-3.77-4.86-3.77S281.35,211.59,281.35,213.36Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M287.36,235.89s-.34-5.33,4.15-5.33,3.43,9.39-2.08,9.39Z",
    style: {
      fill: "#ffa8a7"
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAuthentication);
export default __webpack_public_path__ + "static/media/authentication.80bcb1fb416fdb0609f1a88810948586.svg";
export { ForwardRef as ReactComponent };